import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import MarkdownViewerPage from "./components/pages/MarkdownViewerPage";
import AuthLayout from "./components/templates/AuthLayout";
import MainLayout from "./components/templates/MainLayout";
import ProtectedRoute from "./features/auth/components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Help from "./pages/Help";
import Intake from "./pages/Intake";
import NotFound from "./pages/NotFound";
import Workshop from "./pages/Workshop";
import TaskProvider from "./providers/TaskProvider";

function App() {
  // Check if environment variables are properly set
  const showEnvWarning = !import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  return (
    <TaskProvider>
      <Router>
        <Routes>
          {/* Auth routes */}
          <Route path="/sign-in" element={<AuthLayout type="signin" />} />
          <Route path="/sign-up" element={<AuthLayout type="signup" />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout showEnvWarning={showEnvWarning}>
                  <Dashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/intake"
            element={
              <ProtectedRoute>
                <MainLayout showEnvWarning={showEnvWarning}>
                  <Intake />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/workshop"
            element={
              <ProtectedRoute>
                <MainLayout showEnvWarning={showEnvWarning}>
                  <Workshop />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <MainLayout showEnvWarning={showEnvWarning}>
                <Help />
              </MainLayout>
            }
          />

          {/* Markdown Viewer route */}
          <Route
            path="/view-markdown/:url"
            element={
              <ProtectedRoute>
                <MarkdownViewerPage />
              </ProtectedRoute>
            }
          />

          {/* Welcome route */}
          <Route path="/welcome" element={<AuthLayout type="welcome" />} />

          {/* Not found route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </TaskProvider>
  );
}

export default App;
